import { render, staticRenderFns } from "./expo-inquiry-form.vue?vue&type=template&id=dd497cf2"
import script from "./expo-inquiry-form.vue?vue&type=script&lang=js"
export * from "./expo-inquiry-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports